"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildResponses;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _lodash = require("lodash");
var _moment = _interopRequireDefault(require("moment"));
function buildResponses(survey) {
  var responses = [];
  (0, _keys.default)(survey.data).forEach(function (key) {
    var value = survey.data[key];
    var questionModel = survey.getQuestionByValueName(key);
    if (!(0, _lodash.isEmpty)(questionModel)) {
      var title = questionModel.title;
      var displayValue = value.toString();
      var valuesId = [];
      var choicesCustom = [];
      // Array of elements
      if (!(0, _lodash.isEmpty)(questionModel.choices)) {
        if (!Array.isArray(value)) {
          value = [value];
        }
        if (Array.isArray(value)) {
          var choicesText = [];
          value.forEach(function (v) {
            var _context;
            var choice = (0, _find.default)(_context = questionModel.choices).call(_context, function (c) {
              return c.value === v;
            });
            choicesText.push(choice.text);
            if (choice.uuid) {
              valuesId.push(choice.uuid);
            }
            if (choice.custom) {
              choicesCustom.push(choice.custom);
            }
          });
          displayValue = choicesText.join(', ');
        }
      }
      if (questionModel.inputType === 'date') {
        displayValue = (0, _moment.default)(value).format('MM/DD/YYYY');
      }
      responses.push({
        id: questionModel.uuid || null,
        name: key,
        title: title,
        valueId: (0, _lodash.isEmpty)(valuesId) ? null : valuesId,
        value: value.toString(),
        displayValue: displayValue,
        custom: choicesCustom
      });
    }
  });
  return responses;
}
//# sourceMappingURL=buildResponses.js.map